import { useState, useEffect } from 'react'
import MenuPage from '@/pages/MenuPage'
import QRPage from '@/pages/QRPage'
import { LanguageProvider } from '@/hooks/LanguageContext'
import { CartProvider } from '@/hooks/CartContext'
import { LaunchSplash } from '@/components/common/LaunchSplash'

// ============================================================================
// Simple Hash-Based Router
// ============================================================================

type Route = 'menu' | 'qr'

function getCurrentRoute(): Route {
  if (typeof window === 'undefined') return 'menu'

  const hash = window.location.hash.replace('#/', '').replace('#', '')
  const path = window.location.pathname.toLowerCase()

  if (hash === 'qr' || hash === 'qr-code' || path.includes('/qr')) {
    return 'qr'
  }

  return 'menu'
}

function App() {
  const [route, setRoute] = useState<Route>(getCurrentRoute())
  const [splashDone, setSplashDone] = useState(() => {
    if (typeof window === 'undefined') return false
    return sessionStorage.getItem('omnirise-splash-seen') === '1'
  })

  useEffect(() => {
    const handleRouteChange = () => {
      setRoute(getCurrentRoute())
    }

    window.addEventListener('hashchange', handleRouteChange)
    window.addEventListener('popstate', handleRouteChange)

    return () => {
      window.removeEventListener('hashchange', handleRouteChange)
      window.removeEventListener('popstate', handleRouteChange)
    }
  }, [])

  // Navigate function for programmatic routing
  const navigate = (newRoute: Route) => {
    if (newRoute === 'qr') {
      window.location.hash = '/qr'
    } else {
      window.location.hash = '/'
    }
    setRoute(newRoute)
    window.scrollTo(0, 0)
  }

  // Expose navigate globally for components to use
  useEffect(() => {
    ;(window as any).navigate = navigate
  }, [])

  return (
    <LanguageProvider defaultLanguage="fr" enabledLanguages={['fr', 'ar', 'en']}>
      <CartProvider>
        {!splashDone && <LaunchSplash onComplete={() => setSplashDone(true)} />}
        {route === 'qr' ? <QRPage /> : <MenuPage />}
      </CartProvider>
    </LanguageProvider>
  )
}

export default App
